import script from "./ComparisonComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComparisonComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ComparisonComponent.vue?vue&type=style&index=0&id=1fc66c7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc66c7c"]])

export default __exports__